import React from 'react';
import PropTypes from 'prop-types';
import browserHistory from 'react-router/lib/browserHistory';

// Helpers
import withDetailsPopup from './DetailsPopupContainer';

const withDetailsPopupPage = (Wrapped) => {
  class DetailsPopupPageWrapper extends React.Component {
    componentDidMount() {
      this.props.checkIsDetailsPopupOpen();

      this.historyListener = browserHistory.listen(({ action }) => {
        if (action === 'POP') {
          this.props.checkIsDetailsPopupOpen();
        }
      });
    }

    componentWillReceiveProps(nextProps) {
      if (!nextProps.isDetailsModalOpen && this.props.isDetailsModalOpen) {
        this.props.closePopupWithDetails();
      }
    }

    componentWillUnmount() {
      if (this.historyListener) {
        this.historyListener();
      }
    }

    render() {
      return <Wrapped {...this.props} />;
    }
  }

  DetailsPopupPageWrapper.propTypes = {
    isMobile: PropTypes.bool,
    locale: PropTypes.string,
    openPopupWithDetails: PropTypes.func,
    closePopupWithDetails: PropTypes.func,
    isDetailsModalOpen: PropTypes.bool,
    checkIsDetailsPopupOpen: PropTypes.func
  };

  return withDetailsPopup(DetailsPopupPageWrapper);
};

export default withDetailsPopupPage;
